import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { format } from "date-fns";

const formatDateTime = (dateString) => {
  try {
    return format(new Date(dateString), "MMM dd, yyyy HH:mm");
  } catch (error) {
    return dateString;
  }
};

export const exportToPDF = (workOrders) => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(18);
  doc.text("Work Orders Report", 14, 20);

  // Date
  doc.setFontSize(10);
  doc.text(`Generated on: ${format(new Date(), "MMM dd, yyyy HH:mm")}`, 14, 28);

  // Table
  const tableData = workOrders.map((wo) => [
    wo.work_order_number,
    wo.site_name,
    wo.engineer_name || "Unassigned",
    wo.description.substring(0, 50) + (wo.description.length > 50 ? "..." : ""),
    wo.priority || "N/A",
    wo.is_chargeable !== false ? "Chargeable" : "Non-Chargeable",
    formatDateTime(wo.start_datetime),
    formatDateTime(wo.end_datetime),
    wo.status,
  ]);

  doc.autoTable({
    startY: 35,
    head: [["WO Number", "Site Name", "Engineer", "Description", "Priority", "Billing", "Start Date", "End Date", "Status"]],
    body: tableData,
    theme: "grid",
    styles: {
      fontSize: 8,
      cellPadding: 3,
    },
    headStyles: {
      fillColor: [15, 23, 42],
      textColor: 255,
      fontStyle: "bold",
    },
  });

  doc.save(`work-orders-${format(new Date(), "yyyy-MM-dd")}.pdf`);
};

export const exportToExcel = (workOrders) => {
  const excelData = workOrders.map((wo) => ({
    "WO Number": wo.work_order_number,
    "Site Name": wo.site_name,
    "Engineer": wo.engineer_name || "Unassigned",
    "Description": wo.description,
    "Priority": wo.priority || "N/A",
    "Billing": wo.is_chargeable !== false ? "Chargeable" : "Non-Chargeable",
    "Start Date": formatDateTime(wo.start_datetime),
    "End Date": formatDateTime(wo.end_datetime),
    "Status": wo.status,
    "Job Done Remark": wo.job_done_remark || "",
    "Comments Count": wo.comments?.length || 0,
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Work Orders");

  // Set column widths
  worksheet["!cols"] = [
    { wch: 12 },
    { wch: 20 },
    { wch: 20 },
    { wch: 40 },
    { wch: 10 },
    { wch: 20 },
    { wch: 20 },
    { wch: 15 },
    { wch: 15 },
  ];

  XLSX.writeFile(workbook, `work-orders-${format(new Date(), "yyyy-MM-dd")}.xlsx`);
};